/* eslint-disable react-hooks/exhaustive-deps */
// Core
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// Styles
import { CommonGlassContainer, H1Head, Label } from "assets/styles/globalStyles";
import { RadioChangeEvent } from "antd";

// Types
import {
    AwardLists,
    FounderWrapper,
    YearHead
} from "./styles";

// Components
import Loader from "components/Loader";
import Footer from "components/Footer";

// Others
import { fetchData } from "utils/fetch";
import { restAPIs } from "utils/restAPIs";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { WinningCard } from "pages/Homepage/styles";
import { FontSizes, FontWeight } from "utils/enums";
import { colors } from "assets/styles/colors";

import AOS from "aos";
import { Button, Flex, Radio, Tooltip } from "antd";

const AwardList: React.FC = () => {
    const { currentLang } = useSelector((store: any) => store.commonData);
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const { t } = useTranslation();
    const [pageLoading, setPageLoading] = useState(false);
    const [awards, setData] = useState([]);
    const [type, setAlignment] = useState('year');
    const [isAuthor, setAuthor] = useState(false)
    const filterOptions = [
        {
            label: 'By Year',
            value: 'year',
        },
        {
            label: 'By Category',
            value: 'categoryId',
        }

    ];
    const filterIcons = {
        CameraswitchIcon: <svg xmlns="http://www.w3.org/2000/svg" height="16" width="20" viewBox="0 0 640 512"><path d="M213.1 64.8L202.7 96H128c-35.3 0-64 28.7-64 64V416c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V160c0-35.3-28.7-64-64-64H437.3L426.9 64.8C420.4 45.2 402.1 32 381.4 32H258.6c-20.7 0-39 13.2-45.5 32.8zM448 256c0 8.8-7.2 16-16 16H355.3c-6.2 0-11.3-5.1-11.3-11.3c0-3 1.2-5.9 3.3-8L371 229c-13.6-13.4-31.9-21-51-21c-19.2 0-37.7 7.6-51.3 21.3L249 249c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l19.7-19.7C257.4 172.7 288 160 320 160c31.8 0 62.4 12.6 85 35l23.7-23.7c2.1-2.1 5-3.3 8-3.3c6.2 0 11.3 5.1 11.3 11.3V256zM192 320c0-8.8 7.2-16 16-16h76.7c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8L269 347c13.6 13.4 31.9 21 51 21c19.2 0 37.7-7.6 51.3-21.3L391 327c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-19.7 19.7C382.6 403.3 352 416 320 416c-31.8 0-62.4-12.6-85-35l-23.7 23.7c-2.1 2.1-5 3.3-8 3.3c-6.2 0-11.3-5.1-11.3-11.3V320z" /></svg>,
    }

    useEffect(() => {
        AOS.init({
            duration: 800, // Animation duration in milliseconds
            easing: 'ease-in-out', // Easing function for the animation
            once: false, // Ensures the animation runs every time the element is in view
        });

        const handleScroll = () => {
            AOS.refresh();
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    const fetchAwards = async (type = 'year') => {
        setLoading(true)
        const res = await fetchData(restAPIs.awardsByType(currentLang?.id, type));
        setData(res.awards)
        setLoading(false);
    }

    useEffect(() => {
        fetchAwards()
        window.scrollTo(0, 0);
    }, [currentLang]);

    const handleBook = (bookId: any) => {
        navigate(`/book/${bookId}`)
    }

    const toggleImg = () => {
        setAuthor(!isAuthor)
    }



    const handleChange = (e: RadioChangeEvent) => {
        const value = e.target.value;
        if (value !== null) {
            setAlignment(value);
            fetchAwards(value);
        }
    };

    const handleClickOnSeeAll = (typeId: any) => {
        navigate(`/awards/list/${type}/${typeId}`)
    }


    // if (pageLoading) return <Loader />;

    return (
        <>
            <FounderWrapper
                direction={(currentLang?.id) == 1 ? "rtl" : "ltr"}
            >
                <div className="container">

                    <div className="row justify-content-center">
                        <div className="col-md-11">
                            <CommonGlassContainer>
                                <Flex justify="space-between" align="center" gap={20}>
                                    <motion.div
                                        style={{ marginLeft: '-8px' }}
                                        className='mb-5'
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >
                                        <Label className="fade-left" fontSize={FontSizes.h1} fontWeight={FontWeight.bold} marginTop={0} marginBottom={5}>{t('ibn_battuta_award')}</Label>
                                    </motion.div>
                                    <motion.div
                                        style={{ marginLeft: '-8px',gap:'10px' }}
                                        className='mb-5'
                                        initial={{ opacity: 0, x: -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.5 }}
                                    >


                                        <Button className='__filt_btn' style={{ margin: '10px 10px' }} title={isAuthor ? 'Switch to see book images' : 'Switch to see author images'} onClick={() => toggleImg()} icon={filterIcons?.CameraswitchIcon}><span>{isAuthor ? 'Books' : 'Awardees'}</span></Button>
                                        <Radio.Group
                                            options={filterOptions}
                                            onChange={handleChange}
                                            value={type}
                                            optionType="button"
                                            buttonStyle="solid"
                                        />
                                    </motion.div>
                                </Flex>

                                {
                                    isLoading ? <Loader /> :
                                        awards && awards.map((award: any, idx: any) => {
                                            return (
                                                <div className='__single_set mb-5' key={idx}>
                                                    <YearHead>
                                                        <h1 className='__sec_hd'>{award.typeName}</h1>
                                                        <button onClick={() => handleClickOnSeeAll(award.typeId)}>
                                                            {t('see_all')}
                                                        </button>
                                                    </YearHead>
                                                    <AwardLists>
                                                        {
                                                            award?.winners?.map((item: any, i: any) => {
                                                                return (
                                                                    <div
                                                                        className="mb-4"
                                                                        style={{ width: '100%' }}
                                                                        key={i}
                                                                        data-aos="fade-left" data-aos-delay={i * 200}
                                                                    >
                                                                        <WinningCard className="fade-left" onClick={() => handleBook(item.bookId)}>
                                                                            <div className="book">
                                                                                <div className="cover" style={{ backgroundImage: `url(${isAuthor ? item.authorImage : item.coverImage})` }}></div>
                                                                                <div className="__category">{item.categoryName}</div>
                                                                            </div>

                                                                            <div className="__content">
                                                                                <Tooltip title={item.bookName}>
                                                                                    <Label fontWeight={FontWeight.bold} color={colors.primary} fontSize={FontSizes.h2} marginBottom={15}>
                                                                                        {item.bookName}
                                                                                    </Label>
                                                                                </Tooltip>
                                                                                <Tooltip title={`${item.authorName}`}>
                                                                                    <p className="__author">{item.authorName}</p>
                                                                                </Tooltip>
                                                                                <Tooltip title={` ${item.categoryName}`}>
                                                                                    <p>{item.categoryName}</p>
                                                                                </Tooltip>
                                                                                <p style={{ color: colors.darkPrimary }}>{item.year}</p>
                                                                            </div>
                                                                        </WinningCard>
                                                                    </div>
                                                                )
                                                            })
                                                        }
                                                        <div className='__dummy' data-aos="fade-left" data-aos-delay={4 * 200} onClick={() => handleClickOnSeeAll(award.typeId)}>
                                                            {t('see_all')}
                                                        </div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>

                                                    </AwardLists>
                                                </div>
                                            )
                                        }
                                        )
                                }
                            </CommonGlassContainer>
                        </div>
                    </div>
                </div>
            </FounderWrapper>
        </>
    );
};

export default AwardList;

